import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';
import { Card, CardContent } from '@/components/ui/card';
import { InternalTeamList } from './InternalTeamList';
import { CampaignManager } from './CampaignManager';
import { Users, Megaphone, BarChart3, DollarSign } from 'lucide-react';

export function MarketingManagerDashboard() {
  const { data: stats } = useQuery({
    queryKey: ['marketing-manager-stats'],
    queryFn: async () => {
      const deptRes = await supabase.from('internal_departments').select('id').eq('name', 'Marketing').single();
      const deptId = deptRes.data?.id || '';
      const [teams, campaigns, tasks] = await Promise.all([
        supabase.from('internal_teams').select('*', { count: 'exact', head: true }).eq('department_id', deptId),
        supabase.from('marketing_campaigns').select('status, budget'),
        supabase.from('internal_tasks').select('*', { count: 'exact', head: true }),
      ]);
      const campaignData = campaigns.data || [];
      const totalBudget = campaignData.reduce((sum: number, c: any) => sum + (Number(c.budget) || 0), 0);
      return {
        totalTeams: teams.count || 0,
        totalCampaigns: campaignData.length,
        activeCampaigns: campaignData.filter((c: any) => c.status === 'active').length,
        totalBudget,
      };
    },
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Marketing Manager Dashboard</h2>
        <p className="text-muted-foreground">Oversee all marketing operations</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card><CardContent className="p-4 flex items-center gap-3"><Users className="h-8 w-8 text-blue-500" /><div><p className="text-2xl font-bold">{stats?.totalTeams || 0}</p><p className="text-xs text-muted-foreground">Teams</p></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><Megaphone className="h-8 w-8 text-orange-500" /><div><p className="text-2xl font-bold">{stats?.totalCampaigns || 0}</p><p className="text-xs text-muted-foreground">Campaigns</p></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><BarChart3 className="h-8 w-8 text-green-500" /><div><p className="text-2xl font-bold">{stats?.activeCampaigns || 0}</p><p className="text-xs text-muted-foreground">Active</p></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><DollarSign className="h-8 w-8 text-primary" /><div><p className="text-2xl font-bold">{(stats?.totalBudget || 0).toLocaleString()}</p><p className="text-xs text-muted-foreground">Total Budget</p></div></CardContent></Card>
      </div>

      <InternalTeamList departmentName="Marketing" canManage />
      <CampaignManager viewAll />
    </div>
  );
}
